<script>
import moment from 'moment'
import axios from 'axios'
import config from '@/config.js'
import ClickOutside from 'vue-click-outside'

export default {
  directives: {
    ClickOutside,
  },
  props: ['data'],
  data() {
    return {
      searchCoupon: '',
      showCoupons: false,
      couponPaging: {
        size: 20,
        page: 1      
      },
      couponTotal:0,
      couponCount:0,
      coupons:[],
      applied_discount:false,
      moment    
    }
  },
  methods: {
    clearDiscountCode(){
      this.$emit('clearDiscountCode')
    },
    selectDiscount(discount){      
      this.searchCoupon='';
      this.$emit('selectDiscount',discount)     
      this.showCoupons=false
    },    
   
    checkdisabled(discount) {            
      let discount_amount=0;        
      let price =  this.data.price;  
      let totalQuantity=this.data.totalQuantity;

      if(this.data.cartSummary.length > 0){
          totalQuantity=0;
          price = 0;
          this.data.cartSummary.map(async (e) => {      
            totalQuantity = totalQuantity + e.qty;     
            let subPrice = (e.price ? e.price : e.priceOriginal) * e.qty;
              if (e.whosaleData) {
                e.whosaleData.map((one) => {
                  if (one.count && parseInt(one.count) <= parseInt(e.qty)) {
                    subPrice = one.price * parseInt(e.qty);
                  }               
                });
              }             
              price = price + subPrice;     
           
        });
      }      

      if (discount.product_type !== this.data.productType) {
        return false;
      }

     if(discount.minimum_requirements.type=='minimum_purchase'){         
        if(Number(discount.minimum_requirements.value)>this.data.totalPrice){
          return discount_amount > 0 
        }        
      }else if(discount.minimum_requirements.type=='minimum_quantity'){       
        if(Number(discount.minimum_requirements.value)>totalQuantity){
          return discount_amount > 0 
        }        
      } 

      if(discount.payment_type=='cod' || this.data.payload.payment=='COD'){           
        if(this.data.payload.payment!='COD' && discount.payment_type=='cod'){        
          return discount_amount > 0 
        }else if(this.data.payload.payment=='COD' && discount.payment_type=='non_cod'){        
          return discount_amount > 0 
        }       
      } 

      
      if(discount.discount_type=="moneyOffProduct"){


          if(discount.discount_value.type=="fixed"){                   
            discount_amount=(Number(discount.discount_value.value));           
          }else{
            discount_amount =(price *Number(discount.discount_value.value)) / 100;                                        
                           
          }       
          
        }else if(discount.discount_type=="moneyOffOrder"){
          if(discount.discount_value.type=="fixed"){                   
            discount_amount=Number(discount.discount_value.value);         
          }else{
            discount_amount =(this.data.totalPrice *Number(discount.discount_value.value)) / 100;                             
                    
          }  
        }else if(discount.discount_type=="moneyOffShipping") {
          if (this.data.payload.deliveryPrice) {
            if (discount.discount_value.applies_to.shipping_type=='all' || discount.discount_value.applies_to.shipping_type==this.data.payload.deliveryCourier) {
              if (discount.discount_value.type=="fixed"){                   
                discount_amount=Number(discount.discount_value.value);         
              } else{
                discount_amount =(this.data.payload.deliveryPrice *Number(discount.discount_value.value)) / 100;    
              }
              return discount_amount > 0        
            }
          }

          return true;
        }     
    
        return discount_amount > 0        
    },
    getListsPosition() {
      const rect = this.$refs.input.getBoundingClientRect()
      const isOverflow = window.innerHeight - rect.bottom < 400
      const top = isOverflow ? (rect.bottom || 0) - (320 + 38) : (rect.bottom || 0)

      if (isOverflow) {
        this.$refs['dropdown'].setAttribute("data-position", "top");
      } else {
        this.$refs['dropdown'].removeAttribute("data-position");
      }
      
      return {
        left: `${rect.x ? rect.x:  0}px`,
        top: `${top}px`,
        width: `${rect.width ? rect.width: 300 }px`,
      }
    },
    updateDropdownPosition() {
      const position = this.getListsPosition()
      this.$refs['dropdown'].style.transform = `translate(${position.left}, ${position.top})`
      this.$refs['dropdown'].style.width = position.width
    },
    openCoupons(e) {
      this.updateDropdownPosition()
      if (e.target.value.length > 1) {
        this.showCoupons = true
      }
    },
    close() {
      this.showCoupons = false
    },
    onClickDropdown(e) {
      if (e.target.classList.contains('coupon-entry__dropdown')) {
        this.close()
      }
    },
    updateDiscountLists(discounts,replace){   
      this.$emit('updateDiscountLists',discounts,replace)
    },

    async applyCoupon(){
      this.applied_discount=true
      const search=this.searchCoupon.length > 3 ? this.searchCoupon :'';
      const response = await axios.get(config.api +"product/discountList/"+this.data._id+"?offset="+new Date().getTimezoneOffset()+"&user_id="+this.data.user_id+"&search="+search+"&includeHiden=true");      

      if (response && response.data.success) {
        // Step 1: Get fields with non-zero counts
        const couponExist = Object.keys(response.data.count).filter(key => response.data.count[key] > 0);

        // Step 2: Collect matching data as an array
        const couponData = couponExist
          .flatMap(field => (Array.isArray(response.data.data[field]) ? response.data.data[field] : []));

        const discountLists = couponData.filter(d=>d.discount_value.applies_to.type=='spcific_products' && d.discount_value.applies_to.products.length > 0 ? d.discount_value.applies_to.products.indexOf(this.data._id) > -1 : true);

       const discount= discountLists.find(x=>x.title==search)
        
        if(discount){
          this.updateDiscountLists(discountLists,false)  
          // const isApply=this.checkdisabled(discount)  
          // if(isApply){
          //   this.$emit('selectDiscount',discount)
          // }       
          this.$emit('selectDiscount',discount)    
          this.coupons=this.data.discountLists
          this.searchCoupon=''
        } else {
          this.$vs.notification({
            color: "danger",
            position: "top-right",
            text: this.$t('coupon.Couponnotfound'),//"Please fix fields error before proceeding to next step",
            duration: 2000,
          });
        }
       
      }else{
          this.coupons=[]
        }
    
    },
    isCouponSelected(code) {
      const selectedDiscount = this.data.payload.discounts.find(discount => discount.code === code);

      return selectedDiscount ? true : false;
    },
    seeAllCoupon() {
      this.$emit('seeAllCoupon', true);
    }
  },
  mounted() {
    this.updateDropdownPosition()
    window.addEventListener('scroll', () => {
      if (this.$refs['dropdown']) {
        this.updateDropdownPosition()
      }
    })
    window.addEventListener('resize', () => {
      if (this.$refs['dropdown']) {
        this.updateDropdownPosition()
      }
    })   
    this.coupons=this.data.discountLists
   
  },
  destroyed() {
    window.removeEventListener('scroll', () => {
      if (this.$refs['dropdown']) {
        this.updateDropdownPosition()
      }
    })
    window.removeEventListener('resize', () => {
      if (this.$refs['dropdown']) {
        this.updateDropdownPosition()
      }
    })
  },
  computed: {
    totalDiscountAmount() {
      let totalAmount = this.data.payload.automaticDiscount.code ? this.data.payload.automaticDiscount.amount : 0;
      for (const discount of this.data.payload.discounts) {
        totalAmount += discount.amount;
      }

      return totalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    totalCountAppliedCoupons() {
      let count = this.data.payload.automaticDiscount.code ? 1 : 0;
      count += this.data.payload.discounts.length;
      
      return count;
    },

    showShippingCouponWarning() {
      if (this.data.shippingType !== "automated") {
        return false;
      }

      if (
        this.data.payload.automaticDiscount.code &&
        !this.data.payload.automaticDiscount.amount
      ) {
        return true;
      }

      return this.data.payload.discounts.some(
        discount => discount.discount_type === "moneyOffShipping"
      ) && !this.data.payload.deliveryPrice;
    }
  }
}
</script>

<template>
  <div class="coupon-entry">
    <label>{{$t('coupon.EnterCouponCode')}}</label>
    <!-- Dropdown -->
    <div v-click-outside="close">
      <div class="flex items-center" style="gap: 8px;">
        <input :class="{'is-invalid':searchCoupon!='' && this.coupons.length==0 && applied_discount}" v-model="searchCoupon" type="text" ref="input" :placeholder="$t('coupon.entercouponhere')" />
        <button :disabled="searchCoupon.length < 4"  @click="applyCoupon" class="theme--tuktuk__button-pink--fill btn-apply-coupon">{{ $t("coupon.Use") }}</button>
      </div>
      <p  v-if="searchCoupon!='' && this.coupons.length==0 && applied_discount" class="fs-12 invalid-feedback">{{$t('coupon.Couponnotmatch')}}</p>
      
      <div v-show="showCoupons" ref="dropdown" class="coupon-entry__dropdown" @click="onClickDropdown">
        <div class="coupon-entry__lists">
          <template v-if="coupons.length>0">
            <label class="coupon-entry__item" :data-selected="isCouponSelected(coupon.title)" :key="`coupon-${index}`" v-for="coupon,index in coupons" >
          
              <input :class="{'disabled':!checkdisabled(coupon)}" :disabled="!checkdisabled(coupon)" @click="checkdisabled(coupon) && selectDiscount(coupon)" :value="coupon.title" name="coupon" type="radio" :checked="isCouponSelected(coupon.title)" />
              <div>
                <p class="coupon-entry__item__name"> {{coupon.title}}</p>
                <template v-if="coupon.minimum_requirements.type == 'minimum_purchase'">
                <p class="coupon-entry__item__description">{{ coupon.minimum_requirements.value ? `Minimum purchase of RP
                  ${Number(coupon.minimum_requirements.value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` :
                  $t('coupon.NoMinPurchaseRequirement') }}</p>
              </template>
              <template v-else-if="coupon.minimum_requirements.type == 'minimum_quantity'">
                <p class="coupon-entry__item__description">{{ coupon.minimum_requirements.value ? `Minimum purchase of
                  ${coupon.minimum_requirements.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} items` : $t('coupon.NoMinPurchaseRequirement') }}</p>

                </template>
                <template v-else>
                <p class="coupon-entry__item__description">{{ $t('coupon.NoMinPurchaseRequirement') }}</p>
              </template>
              <p class="coupon-entry__item__description" v-if="coupon.end_date">                   
                {{ coupon.end_date ? moment(coupon.full_end_date).diff(moment(coupon.full_start_date), 'days')  > 0 ? "Until "+moment(coupon.full_end_date).diff(moment(coupon.full_start_date), 'days')+" days" : 'Until today' : '' }}
              </p>
                <template v-if="coupon.discount_value.type === 'fixed'">
                  <p class="coupon-entry__item__discount">{{$t('coupon.Discount')}} {{ 'RP' +Number(coupon.discount_value.value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</p>

                </template>
                <template v-else>
                  <p class="coupon-entry__item__discount">{{$t('coupon.Discount')}} {{ coupon.discount_value.value ? coupon.discount_value.value + "% " : "" }}
                  </p>
                </template>   
              </div>
              <img src="@/assets/images/illustrations/icon-illustration-coupon-item-normal.svg" alt="O" height="40px" width="40px">
            </label>
          </template>   
          <div  v-else class="flex flex-column items-center justify-center">
            <img src="@/assets/images/empty-state/coupons-empty-red.svg" width="56px" height="56px" alt="Empty" style="margin-bottom: 8px;">
            <p class="color-mute m-0" style="font-size: 14px; font-weight: 500; font-family: TikTokDisplayMedium;">
              {{$t('coupon.Couponnotfound')}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- Selected Coupons -->
    <div class="fff-coupon-applied-container mt-3" v-if="totalCountAppliedCoupons" @click="seeAllCoupon">
      <div class="fff-coupon-applied-icon">
        <img src="@/assets/icons/coupon/coupon-applied.svg" />
      </div>
      <div class="fff-coupon-applied-description">
        <div class="fff-coupon-applied-title">({{ totalCountAppliedCoupons }}) {{ $t("coupon.appliedCoupon.title") }}</div>
        <div class="fff-coupon-applied-subtitle">{{ $t("coupon.appliedCoupon.subtitle") }} <span class="fff-total-discounted">Rp. {{ totalDiscountAmount }} 🌟</span></div>
      </div>
      <div class="fff-coupon-applied-action-icon">
        <img src="@/assets/icons/general/chevron-right-tuktuk.svg" />
      </div>
    </div>

    <div v-if="showShippingCouponWarning" class="fff-shipping-coupon-warning mt-1">
      <img src="@/assets/icons/coupon/alert-circle.svg" />
      <span class="fff-text-error">{{ $t("coupon.errorMessage.pleaseFillShippingAdress") }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.coupon-entry {
  padding: 0 16px 0px;

  .bordered-selected-coupon {
    background: #FFE3E3;
    padding: 8px 4px;
    border-radius: 8px;
  }

  label {
    color: #203551;
    font-family: TikTokDisplayMedium;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 6px !important;
  }
  input {
    font-size: 14px;
  }
  input[type=text] {
    width: 100%;
    height: 38px;
    padding: 10px 12px;
    border: 1px solid #E0E9F4;
    border-radius: 2px;
    box-shadow: 0px 1px 2px 0px #1018280D;
    
    &.is-invalid {
      border-color: #E12121;
    }
  }
  .invalid-feedback {
    font-size: 12px;
    margin: 6px 0 0;
  }
  .btn-apply-coupon {
    flex-shrink: 0;
    width: 72px;
    min-height: 38px !important;
    height: 38px !important;
    padding: 0;

    &:disabled {
      opacity: 1 !important;
      background-color: #BFCEE0 !important;
      border-color: #BFCEE0 !important;
      cursor: default;
    }
  }

  &__dropdown {
    z-index: 2;
    position: fixed;
    top: 0;
    left: 0;
    height: 320px;

    &[data-position=top] {
      display: flex;
      flex-direction: column;
      justify-content: end;
    }
  }

  &__lists {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    max-height: 320px;
    overflow-y: auto;
    background: #FFF;
    border-radius: 10px;
    box-shadow: 0px 5px 20px 0px #2035511A;
  }

  &__selected {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 8px 10px;
    margin-top: 16px;
    background: #EB435B0D;
    border: 1px solid #EB435B26;
    border-radius: 4px;

    p {
      margin: 0;
    }

    &__name,
    &__name span {
      color: #203551;
      font-weight: 500;
      font-size: 12px;
      font-family: TikTokDisplayMedium;
      line-height: 18px;
    }

    &__name span {
      color: #6C7E95;
    }

    &__discount {
      color: #EB435B;
      font-weight: 700;
      font-size: 12px;
      font-family: TikTokDisplayMedium;
      line-height: 18px;
    }

    &__description {
      opacity: 0.4;
      color: #15171C;
      font-weight: 400;
      font-size: 12px;
      font-family: TikTokDisplayRegular;
      line-height: 18px;
    }

    [role=button] {
      cursor: pointer;
    }
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px 8px;
    border: 1px solid #E0E9F4;
    border-radius: 8px;
    cursor: pointer;

    &[data-selected=true] {
      background: #FEEBEB;
      border: 1px solid #F75656;
    }

    &__name {
      color: #EB435B;
      font-weight: 600;
      font-size: 13px;
      font-family: TikTokDisplayMedium;
      line-height: 16px;
    }

    &__discount {
      color: #EB435B;
      font-weight: 400;
      font-size: 13px;
      font-family: TikTokDisplayRegular;
      line-height: 18px;
    }

    &__description {
      color: #6C7E95;
      font-weight: 400;
      font-size: 11px;
      font-family: TikTokDisplayRegular;
      line-height: 16px;
    }
    
    input[type=radio] {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-color: #FFF;
      margin: 0;
      font: inherit;
      color: currentColor;
      width: 20px;
      height: 20px;
      border: 1px solid #D5DAF1;
      border-radius: 50%;

      transition: border 50ms ease-out;
      align-self: center;
      display: grid;
      place-content: center;
      cursor: pointer;

      &:checked {
        border: 6px solid #EB435B;
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 0.6;

        &:not(:checked) {
          background-color: #D5DAF1;
          opacity: 0.4;
        }
      }
    }

    div {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      gap: 2px;
      
      p {
        margin: 0;
      }
    }

    img {
      flex-shrink: 0;
    }
  }

  .fff-coupon-applied-container {
    height: 58px;
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 9px 12px;
    border-radius: 8px;
    border: 1px solid #E0E9F4;
    background-color: #FFFFFF;
    cursor: pointer;

    .fff-coupon-applied-description {
      display: flex;
      flex-direction: column;

      .fff-coupon-applied-title {
        font-size: 14px;
        font-weight: 700;
        text-align: left;
        color: #F53535;
      }

      .fff-coupon-applied-subtitle {
        font-size: 12px;
        font-weight: 400;
        text-align: left;
        color: #203551;

        .fff-total-discounted {
          font-size: 12px;
          font-weight: 700;
          text-align: left;
          color: #203551;
        }
      }
    }

    .fff-coupon-applied-action-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: auto;
    }
  }

  .fff-shipping-coupon-warning {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: start;

    .fff-text-error {
      color:#F53535;
      font-family: Inter;
      font-size: 11px;
      font-style: normal;
      font-weight: 400;
      line-height: 14px;
      word-break: break-word;
    }
  }
}
</style>